<iframe title = ""
  *ngIf="invalidScanFlag || troubleFlag || noticeFlag || pigletFlag"
  type="audio/mp3"
  allow="autoplay 'self'"
  style="display: none"
  src="../../../assets/sounds/beep-3.mp3"
>
</iframe>

<audio autoplay #audio>
    <source *ngIf="invalidScanFlag" [src]="invalidScan" type="audio/mp3" height="0" width="0" />
    <source *ngIf="troubleFlag" [src]="trouble" type="audio/mp3" height="0" width="0" />
    <source *ngIf="noticeFlag" [src]="notice" type="audio/mp3" height="0" width="0" />
    <source *ngIf="pigletFlag" [src]="piglet" type="audio/wav" height="0" width="0" />
</audio>
